import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import {
    CmpsIconModule,
    CmpsPortalModule,
    CmpsTooltipModule,
} from '@cmps/ng-uikit';

import { CmpsCommonModule } from '../common/common.module';
import { CmpsHumanInsightModule } from '../human-insight/human-insight.module';
import { CmpsInsightModule } from '../insight/insight.module';
import { CmpsPerformanceInsightModule } from '../performance-insight/performance-insight.module';
import { CmpsLazyRouterModule } from '../route.module';
import { Widgets } from '../widget/widget.model';
import { CmpsWidgetModule } from '../widget/widget.module';

import { InsightExplorerRoutes } from './insight-explorer.route';
import { TabRenameInsightExplorerComponent } from './tab-rename.ie.component';
import { TabContent, TabsetComponent, TabsetContent } from './tabset.component';
import { ViewViewerInsightExplorerComponent } from './view-viewer.ie.component';
import { WidgetInsightExplorerComponent } from './widget.ie.component';
import { WizardInsightExplorerComponent } from './wizard.ie.component';

const ModuleWidgets: Widgets = [
    {
        typeId: 23,
        component: WidgetInsightExplorerComponent,
        noEncapsulate: true,
    },
];

@NgModule({
    imports: [
        CommonModule,
        ReactiveFormsModule,
        CmpsCommonModule,
        CmpsLazyRouterModule.forChild(InsightExplorerRoutes),
        CmpsWidgetModule.forChild(ModuleWidgets),
        CmpsHumanInsightModule,
        CmpsPerformanceInsightModule,
        CmpsInsightModule,
        CmpsIconModule,
        CmpsPortalModule,
        CmpsTooltipModule,
    ],
    declarations: [
        TabsetContent,
        TabContent,
        TabsetComponent,
        WizardInsightExplorerComponent,
        TabRenameInsightExplorerComponent,
        WidgetInsightExplorerComponent,
        ViewViewerInsightExplorerComponent,
    ],
    exports: [WidgetInsightExplorerComponent],
})
export class CmpsInsightExplorerModule {}
